import { Brain, BarChart3, LineChart } from "lucide-react";
import { useI18n } from "@/i18n/I18nProvider";

const ICONS = [Brain, BarChart3, LineChart];

export default function Problem() {
    const { t } = useI18n();
    const p = t.problem;
    return (
        <section
            id="problem"
            data-testid="problem-section"
            className="relative py-24 md:py-32 border-t border-white/5"
        >
            <div className="max-w-[1400px] mx-auto px-6 md:px-12">
                <div className="grid lg:grid-cols-12 gap-10 mb-16 reveal">
                    <div className="lg:col-span-5">
                        <div className="text-xs tracking-[0.22em] uppercase font-bold text-[#D4FF00] mb-4">
                            {p.tag}
                        </div>
                        <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl tracking-tighter heading-clamp">
                            {p.headline}{" "}
                            <span className="text-[#D4FF00]">{p.headlineAccent}</span>
                        </h2>
                    </div>
                    <div className="lg:col-span-6 lg:col-start-7 self-end">
                        <p className="text-lg text-white/65 leading-relaxed">{p.sub}</p>
                    </div>
                </div>

                <div className="grid md:grid-cols-3 gap-5 md:gap-6">
                    {p.cards.map((card, i) => {
                        const Icon = ICONS[i];
                        return (
                            <div
                                key={card.title}
                                data-testid={`problem-card-${i}`}
                                className="card-hover relative rounded-2xl border border-white/10 bg-[#071B12] p-7 md:p-8 reveal"
                                style={{ transitionDelay: `${i * 90}ms` }}
                            >
                                <div className="flex items-center justify-between mb-8">
                                    <div className="h-12 w-12 rounded-xl bg-[#0E2B1E] grid place-items-center border border-white/10">
                                        <Icon size={22} className="text-[#D4FF00]" />
                                    </div>
                                    <div className="text-[10px] tracking-[0.22em] uppercase font-bold text-white/40">
                                        {card.tag}
                                    </div>
                                </div>
                                <div className="font-display text-7xl font-bold text-white/[0.06] absolute top-4 right-6 tabular pointer-events-none">
                                    0{i + 1}
                                </div>
                                <h3 className="font-display font-bold text-2xl md:text-3xl text-white mb-3">
                                    {card.title}
                                </h3>
                                <p className="text-white/65 leading-relaxed text-[15px]">
                                    {card.body}
                                </p>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
